export default __webpack_public_path__ + "static/965-b6753ceaedad192921b61033177a72e6.gif";